import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Keeps the native navigation bar in sync with the store hero without sending
// scroll positions continuously across the bridge.
export default class extends BridgeComponent {
  static component = "store-header"

  connect() {
    super.connect()

    this.heroVisible = true
    this.layoutRoot = this.element.closest(".main-nav-store")

    // Android reads the store name from `title` (it doesn't observe the page
    // title in full screen); iOS gets it natively and ignores it here.
    this.send("connect", { heroVisible: true, title: document.title }, response => {
      const navigationHeight = Number(response.data.navigationHeight)
      if (!Number.isFinite(navigationHeight) || navigationHeight <= 0) return

      this.layoutRoot?.style.setProperty(
        "--native-navigation-height",
        `${navigationHeight}px`
      )

      this.#observeHero()
    })

    requestAnimationFrame(() => this.#observeHero())
  }

  disconnect() {
    this.observer?.disconnect()
    // Turbo puede clonar la tienda después de disconnect. Conservar la altura
    // evita que el sticky use el fallback mientras espera al bridge al volver.
    this.send("disconnect")
    super.disconnect()
  }

  #observeHero() {
    this.observer?.disconnect()

    const navigationHeight = this.#navigationHeight()

    this.observer = new IntersectionObserver(
      ([entry]) => this.#updateVisibility(entry.isIntersecting),
      {
        root: null,
        rootMargin: `-${navigationHeight}px 0px 0px 0px`,
        threshold: 0
      }
    )

    this.observer.observe(this.element)
  }

  #updateVisibility(heroVisible) {
    if (this.heroVisible === heroVisible) return

    this.heroVisible = heroVisible
    this.send("visibility", { heroVisible })
  }

  #navigationHeight() {
    const probe = document.createElement("div")
    probe.setAttribute("aria-hidden", "true")
    probe.style.cssText = [
      "position:fixed",
      "visibility:hidden",
      "pointer-events:none",
      "height:var(--native-navigation-height, 96px)"
    ].join(";")

    document.body.appendChild(probe)
    const height = Math.round(probe.getBoundingClientRect().height)
    probe.remove()

    return height || 96
  }
}
